module.exports = __webpack_public_path__ + "img/Icon-Close.aab14c2e.svg";